import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class Helpers {

  isApiUrl(req: any) {
    return req.url.startsWith(environment.urlAPI);
  }

  isSameOriginUrl(req: any) {
    if (req.url.startsWith(`${window.location.origin}/`)) return true;
    if (req.url.startsWith(`//${window.location.host}/`)) return true;
    if (/^\/[^\/].*/.test(req.url)) return true;
    return false;
  }

  setDataTableSearchDelay() {
    var searchDelay = null;
    setTimeout(function () {
      $('.dataTables_filter input')
        .off('keyup.DT search.DT input.DT paste.DT cut.DT')
        .on('keyup.DT search.DT input.DT paste.DT cut.DT', function (e) {
          var search = $('div.dataTables_filter input').val();
          clearTimeout(searchDelay);
          searchDelay = setTimeout(function () {
            if (search != null) {
              $.fn.dataTable.tables({ api: true, visible: true }).search(search).draw();
            }
          }, 1000);
        });
    }, 1000);
  }

  getFormData(obj: any, form?: FormData, namespace?: string): FormData {
    const that = this;
    const fd = form || new FormData();
    for (const property in obj) {
      if (!obj.hasOwnProperty(property) || obj[property] === undefined || obj[property] === null) continue;
      const value = obj[property];
      if (value instanceof Date) {
        const formKey = namespace ? `${namespace}[${property}]` : property;
        fd.append(formKey, value.toISOString());
      } else if (value instanceof File) {
        const formKey = namespace ? `${namespace}.${property}` : property;
        fd.append(formKey, value);
      } else if (Array.isArray(value)) {
        value.forEach((element, index) => {
          const formKey = namespace ? `${namespace}[${property}]` : property;
          const tempKey = `${formKey}[${index}]`;
          if (typeof element === 'object' && element !== null) {
            that.getFormData(element, fd, tempKey);
          } else {
            fd.append(tempKey, element);
          }
        });
      } else if (typeof value === 'object') {
        const formKey = namespace ? `${namespace}[${property}]` : property;
        that.getFormData(value, fd, formKey);
      } else {
        const formKey = namespace ? `${namespace}[${property}]` : property;
        fd.append(formKey, value);
      }
    }
    return fd;
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getMonths() {
    return [
      { value: 1, label: 'Enero' }, { value: 2, label: 'Febrero' },
      { value: 3, label: 'Marzo' }, { value: 4, label: 'Abril' },
      { value: 5, label: 'Mayo' }, { value: 6, label: 'Junio' },
      { value: 7, label: 'Julio' }, { value: 8, label: 'Agosto' },
      { value: 9, label: 'Septiembre' }, { value: 10, label: 'Octubre' },
      { value: 11, label: 'Noviembre' }, { value: 12, label: 'Diciembre' },
    ];
  }

  isInDevEnvironment() {
    return environment.urlAPI.startsWith('https://localhost');
  }
}
